import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import BasicCard from '../../../../../components/card/basiccard/BasicCard';
import { HEADING } from '../../../../../components/heading/constants/constants';
import Heading from '../../../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import Icons from '../../../../../components/icons/Icons';
import { componentKey as authenticationComponentKey } from '../../../../authentication/AuthenticationSlice'; 
import { componentKey as dataLoaderComponentKey } from '../../../../loaders/dataloader/DataLoaderSlice'; 
import { EDIT_FORM_ORIGIN, FORM_IDS, FORM_SECTION_ROUTES, QUERY_PARAMS } from '../../../constants';
import { componentKey as formsSectionComponentKey, setFinalSaveSingleFormData, setSaveSingleFormSuccessData } from '../../../FormsSectionSlice';
import styles from "./SaveFormSuccess.styles";
import { PermissionReroute, useUserPermissionsInfo } from '../../../../dashboard/hooks/userHooks';
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../../../dashboard/constants/constant';
import useTxNavigate from '../../../../../../libs/txnavigate/TxNavigateHook';
import useTxSearchParams from '../../../../../../libs/txsearchparams/TxSearchParamsHook';
import General from '../../../../../../libs/utility/General';

export default function SaveFormSuccess() {

    const { saveSingleFormSuccessData, finalSaveSingleFormData } = useSelector(state => state[formsSectionComponentKey]);
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey]);
    const { globalFormsNYearsList, forms94xList } = useSelector((state) => state[dataLoaderComponentKey]);

    const [queryParams,setQueryParams] = useTxSearchParams()

    const navigate = useTxNavigate();
    const dispatch = useDispatch();

    const { permissions } = useUserPermissionsInfo();

    useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.CREATE_FORM, permissions, navigate, PAGE_PATH.DASHBOARD)
    },[permissions])
    
    useEffect(() => {
        if(saveSingleFormSuccessData === null){
            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.CREATENEW}`);
        }
    }, [saveSingleFormSuccessData]);

    const handleCreateNewFormClick = () => {
        dispatch(setSaveSingleFormSuccessData(null));
        dispatch(setFinalSaveSingleFormData({}));
        navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.CREATENEW}`);
    }

    const handleViewAddedFormClick = () => {
        const metaDataString = queryParams.get("metaData")
        let metaData = {}
        let queryParamsStr

        if (metaDataString) {
            metaData = JSON.parse(metaDataString)
            queryParamsStr = General.convertObjToQueryString(metaData)
        }

        if (metaData[EDIT_FORM_ORIGIN]) {
            switch (metaData[EDIT_FORM_ORIGIN]) {
                case `${FORM_SECTION_ROUTES.IRSSTATEREJECTED}`:
                    navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.IRSSTATEREJECTED}?${queryParamsStr}`)
                    break;

                case `${FORM_SECTION_ROUTES.FEDERALFORMS}`:
                    const Category = forms94xList[getFormName().replace('-', '').toLowerCase()] ? '944x' : '1099'
                    const manageFederalQueryObj = {
                        Category,
                        PayerId: saveSingleFormSuccessData?.PayerId,
                        TaxYear: saveSingleFormSuccessData?.TaxYear
                    }

                    const manageFederalQueryStr = General.convertObjToQueryString(manageFederalQueryObj)
                    navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.MANAGE}/${FORM_SECTION_ROUTES.FEDERALFORMS}?${manageFederalQueryStr}`);
                    break
                case `${FORM_SECTION_ROUTES.MANAGE_STATE_FORMS}`:
                    const manageStateFormsQueryObj = {
                        [QUERY_PARAMS.FORM_ID]: saveSingleFormSuccessData?.FormId,
                        PayerId: saveSingleFormSuccessData?.PayerId,
                        TaxYear: saveSingleFormSuccessData?.TaxYear
                    }

                    const manageStateFormsQueryStr = General.convertObjToQueryString(manageStateFormsQueryObj)
                    navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.MANAGE}/${FORM_SECTION_ROUTES.MANAGE_STATE_FORMS}?${manageStateFormsQueryStr}`);
                    break
                case `${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}`:
                    if(saveSingleFormSuccessData?.PayrollForm === QUERY_PARAMS.PAYROLL){
                        const reviewApproveQueryObj = {
                            [QUERY_PARAMS.STATUS]: metaData[QUERY_PARAMS.STATUS],
                            [QUERY_PARAMS.STATE_ID]: saveSingleFormSuccessData?.StateName,
                            [QUERY_PARAMS.FORM_ID]: saveSingleFormSuccessData?.FormName,
                            [QUERY_PARAMS.TAX_YEAR]: saveSingleFormSuccessData?.TaxYear,
                            [QUERY_PARAMS.PAYER_ID]: saveSingleFormSuccessData?.PayerId,
                        }
                        const reviewApproveQueryStr = General.convertObjToQueryString(reviewApproveQueryObj);
            
                        navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}/${FORM_SECTION_ROUTES.STATE_PAYROLL_FORMS}?${reviewApproveQueryStr}`);
                    }else{
                        const reviewRejctQueryObj = {
                            [QUERY_PARAMS.FORM_ID]: saveSingleFormSuccessData?.FormId,
                            [QUERY_PARAMS.TAX_YEAR]: saveSingleFormSuccessData?.TaxYear,
                            [QUERY_PARAMS.PAYER_ID]: saveSingleFormSuccessData?.PayerId,
                        }
                        const reviewRejctQueryStr = General.convertObjToQueryString(reviewRejctQueryObj)
                        navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_AND_APPROVE_FORMS}?${queryParamsStr}&${reviewRejctQueryStr}`)
                    }
                    break
                case `${FORM_SECTION_ROUTES.REVIEW_REJECTED_FORMS}`:
                    if(saveSingleFormSuccessData?.PayrollForm === QUERY_PARAMS.PAYROLL){
                        const reviewRejectedQueryObj = {
                            [QUERY_PARAMS.STATE_ID]: saveSingleFormSuccessData?.StateName,
                            [QUERY_PARAMS.FORM_ID]: saveSingleFormSuccessData?.FormName,
                            [QUERY_PARAMS.TAX_YEAR]: saveSingleFormSuccessData?.TaxYear,
                            [QUERY_PARAMS.PAYER_ID]: saveSingleFormSuccessData?.PayerId,
                        }
                        const reviewRejectedQueryStr = General.convertObjToQueryString(reviewRejectedQueryObj);
                        navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_REJECTED_FORMS}/${FORM_SECTION_ROUTES.STATE_PAYROLL_FORMS}?${reviewRejectedQueryStr}`);
                    }else{
                        const reviewRejectedQueryObj = {
                            [QUERY_PARAMS.FORM_ID]: saveSingleFormSuccessData?.FormId,
                            [QUERY_PARAMS.TAX_YEAR]: saveSingleFormSuccessData?.TaxYear,
                            [QUERY_PARAMS.PAYER_ID]: saveSingleFormSuccessData?.PayerId
                        }
                        const reviewRejectedQueryStr = General.convertObjToQueryString(reviewRejectedQueryObj)
                        navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_REJECTED_FORMS}?${reviewRejectedQueryStr}`)
                    }
                    break
                default:
                    break;
            }
        } else if (FORM_IDS[8809] == saveSingleFormSuccessData?.FormId) {
            let manageExtensionQueryObj = {
                TaxYear: saveSingleFormSuccessData?.TaxYear,
                PayerId: saveSingleFormSuccessData?.PayerId,
                Status: 0,
                FormType: finalSaveSingleFormData?.FormType ?? '',
            }
            const manageExtensionQueryStr = General.convertObjToQueryString(manageExtensionQueryObj)

            navigate(`/${FORM_SECTION_ROUTES.EXTENSIONFORMS}?${manageExtensionQueryStr}`);
        }
        else if (saveSingleFormSuccessData?.IsCorrected === "G") {
            const formListingQueryObj = {
                TaxYear: saveSingleFormSuccessData?.TaxYear,
                FormId: saveSingleFormSuccessData?.FormId,
                PayerId: saveSingleFormSuccessData?.PayerId,
                FormType: "Corrected"
            }
            const formListingQueryStr = General.convertObjToQueryString(formListingQueryObj)

            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.SUBMIT}?${formListingQueryStr}`);
        }else if(saveSingleFormSuccessData?.PayrollForm === QUERY_PARAMS.PAYROLL){
            const formListingQueryObj = {
                [QUERY_PARAMS.STATE_ID]: saveSingleFormSuccessData?.StateName,
                [QUERY_PARAMS.FORM_ID]: saveSingleFormSuccessData?.FormName,
                [QUERY_PARAMS.TAX_YEAR]: saveSingleFormSuccessData?.TaxYear,
                [QUERY_PARAMS.PAYER_ID]: saveSingleFormSuccessData?.PayerId,
                [QUERY_PARAMS.STATUS]: saveSingleFormSuccessData?.StatusType,
            }
            const formListingQueryStr = General.convertObjToQueryString(formListingQueryObj)

            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}/${FORM_SECTION_ROUTES.STATEPAYROLL}?${formListingQueryStr}`);
        } else {
            const formListingQueryObj = {
                TaxYear: saveSingleFormSuccessData?.TaxYear,
                FormId: saveSingleFormSuccessData?.FormId,
                PayerId: saveSingleFormSuccessData?.PayerId,
            }
            const formListingQueryStr = General.convertObjToQueryString(formListingQueryObj)

            navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}/${FORM_SECTION_ROUTES.FORM1099}?${formListingQueryStr}`);
        }
    }
     
    const getFormName = () => {
       return globalFormsNYearsList?.Forms[saveSingleFormSuccessData?.FormId]?.FormLabel ?? ""
    }

    return (
        <>
            <div style={styles.successContainer}>
                <BasicCard alignItems="center">
                    <Icons familyName="vec" iconName={VEC_ICON_NAME.CREATE_FORM_SUCCESS} />
                    <Heading type={HEADING.H1} customStyle={styles.cardHeading}>
                        {`You did it, ${signedInUser?.FirstName}! You just ${finalSaveSingleFormData?.FormRecordId && finalSaveSingleFormData?.FormRecordId !== 0 ? "updated" : "added"} form ${getFormName()}!`}
                    </Heading>
                    <div style={styles.payerRecipientRow}>
                        <div style={styles.nameContainer}>
                            <div style={styles.iconDiv}>
                                <Icons familyName="vec" iconName={VEC_ICON_NAME.CREATE_FORM_SUCCESS_PAYER_ICON} />
                            </div>
                            <div style={styles.nameDiv}>
                                <div style={styles.lightText}>
                                    for Payer
                                </div>
                                <div style={styles.nameText}>
                                    {finalSaveSingleFormData?.PayerFirstName} {finalSaveSingleFormData?.PayerLastName}
                                </div>
                            </div>
                        </div>
                        <div style={styles.nameContainer}>
                            <div style={styles.iconDiv}>
                                <Icons familyName="vec" iconName={VEC_ICON_NAME.CREATE_FORM_SUCCESS_RECIPIENT_ICON} />
                            </div>
                            <div style={styles.nameDiv}>
                                <div style={styles.lightText}>
                                    for Recipient
                                </div>
                                <div style={styles.nameText}>
                                    {finalSaveSingleFormData?.PayeeFirstName} {finalSaveSingleFormData?.PayeeLastName}
                                </div>
                            </div>
                        </div>
                    </div>
                </BasicCard>
                <p style={styles.questionText}>What would you like to do next?</p>
                <div style={styles.buttonsContainer}>
                    <Button type={BUTTON_TYPE.PRIMARY} style={styles.button} onClickCb={() => {handleViewAddedFormClick()}}>{`View added form`}</Button>
                    <Button 
                        type={BUTTON_TYPE.PRIMARY} 
                        style={styles.button} 
                        onClickCb={() => handleCreateNewFormClick()}
                    >
                        Add another form
                    </Button>
                    <Button type={BUTTON_TYPE.PRIMARY} style={styles.button} onClickCb={() => navigate(`/`)} >Go to dashboard</Button> 
                </div>
            </div>
        </>
    )
}